import { en } from 'vuetify/src/locale'

export default {
  ...en,
  welcome: 'Welcome',
  signInLinkedIn: 'Sign up with LinkedIn',
  tutorial: {
    slide0: {
      title: 'Why does LPQ exist?',
      text: 'At Lead Pro Quo we want you to find professionals that are recommended by other professionals like you, so that you can be sure that working with someone from Lead Pro Quo means security and trust.'
    },
    slide1: {
      title: 'Why have we created it?',
      text: 'At Lead Pro Quo we want you to sleep easy knowing that all of your contacts are organized and that whenever you need them you can find them quickly through our system of tags.'
    },
    slide2: {
      title: 'But...what is our system of tags?',
      text: 'Through Lead Pro Quo cards you will be able to see the tags assigned to each person that contacts you, what their proposal is, and a minutelong video explaining it. If you like it, you simply swipe right to connect with them. Easy, simple and productive.'
    },
    slide3: {
      title: 'What do we do?',
      text: 'Lead Pro Quo is an exclusive club of professionals where you can find recommendations and approved contacts through an online platform. Find the contact you need when you need it.'
    }
  },
  profile: {
    match: "Match",
    contacts: "Contacts",
    quos: "Quos",
    lives: "Lives",
    personal_skills: "Personal skills",
    professional_skills: "Professional skills",
    your_contacts: "Your contacts"
  }
}
